var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      staticStyle: { padding: "40px 0 40px 0", "background-color": "#ffffff" }
    },
    [
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-row",
            { staticStyle: { padding: "0 16px" } },
            [
              _c(
                "el-col",
                {
                  staticStyle: { display: "flex", "flex-direction": "row" },
                  attrs: { span: 24 }
                },
                [
                  _c("span", { staticClass: "u-connect-p" }, [
                    _vm._v(
                      "UNIFI: Linking Professionals, Unlocking Opportunities"
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "center",
                    padding: "10px 16px"
                  },
                  attrs: { span: 24 }
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "u-connect-btn",
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.joinUConnect()
                        }
                      }
                    },
                    [_vm._v("Join")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "center",
                    padding: "10px 16px"
                  },
                  attrs: { span: 24 }
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "u-connect-btn",
                      attrs: { type: "primary" },
                      on: { click: _vm.redirectToUConnect }
                    },
                    [_vm._v("Sign In")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("el-col", { staticClass: "flex-centered", attrs: { span: 24 } }, [
        _c("img", {
          staticClass: "image-u-connect",
          attrs: { loading: "lazy", src: require("../../assets/three.jpeg") }
        })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ee4b2378", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee4b2378","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/connectingProperties.vue
// module id = null
// module chunks = 